module.exports = __webpack_public_path__ + "static/media/logo.31f01369.gif";